<template>
    <!-- RULES ADD/EDIT MODAL -->
    <b-modal id="modal-activity-logs" ref="modal-activity-logs" @show="showModal" @hidden="hideModal" scrollable>

        <template #modal-title>
            <div class="w-100 text-center">
                <h3>Activity Logs</h3>
            </div>
            <b-avatar rounded size="38" variant="light-primary" class="mr-2">
                <font-awesome-icon :icon="icon.avatar" :title="icon.title" class="fa-2x" />
            </b-avatar>
            <span>{{ truncate(title, 49) }}</span>
        </template>
        <div class="modal-body-scroll">
            <b-overlay :show="isFetchingDataFromServe" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">
                <div>
                    <div v-for="(log, index) in logsArray" :key="log.id" class="d-flex position-relative">
                        <!-- Timeline line + dot -->
                        <div class="d-flex flex-column align-items-center" style="position: relative;">
                            <!-- Dot -->
                            <div class="bg-primary rounded-circle" style="width:10px; height:10px; z-index:1;"></div>

                            <!-- Line -->
                            <div v-if="index !== logsArray.length - 1" class="border-left border-primary flex-grow-1" style="width:2px; min-height:60px; opacity:0.4; margin-top:2px;"></div>
                        </div>

                        <div class="pl-1 pb-3 w-100">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <strong class="badge badge-light-primary text-primary">
                                        {{ log.title }}
                                    </strong>
                                </div>
                                <small class="text-muted">
                                    <i>{{ formatDate(log.created_at) }}</i>
                                </small>
                            </div>

                            <div class="mt-0">
                                <p class="mb-0">{{ log.actions }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="logsArray.length == 0">
                        <h5>No Activities Logs Available</h5>
                    </div>

                </div>
            </b-overlay>
        </div>
        <template #modal-footer="{ ok, cancel, hide }">
            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" @click="cancel()">
                Close
            </b-button>
        </template>

    </b-modal>
</template>

<script>
import {
    BModal, BButton, BOverlay, BAvatar, BTooltip
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment-timezone';
import captureIcons from "@/libs/capture-Icons"

export default {

    components: {
        BModal, BButton, BOverlay, BAvatar, BTooltip
    },
    directives: {
        Ripple,
    },
    props: {
        prop_settingId: {
            type: Number,
            default: () => 0,
        },
    },

    data() {
        return {
            isFetchingDataFromServe: false,
            title: null,
            logsArray: [],
            styleTypeIcons: {},
            icon: {},

        }
    },
    created() {
        const { styleTypeIcons } = captureIcons()
        this.styleTypeIcons = styleTypeIcons
    },
    methods: {
        /**
         * FOR SHOW BOOTSTRAP MODAL
         */

        showModal() {
            this.isFetchingDataFromServe = true
            this.$manageCaptureAPI.post('get-captures-activity', {
                'setting_id': this.prop_settingId ?? 0,
            }).then((response) => {
                this.isFetchingDataFromServe = false
                this.logsArray = response.data.data.activities
                let captureDetail = response.data.data.capture_detail
                this.title = captureDetail.captureBarSay || ''
                this.icon = this.styleTypeIcons[captureDetail.styleType]
            })
        },
        /**
         * FOR HIDE BOOTSTRAP MODAL
         */
        hideModal() {
            this.logsArray = []
        },

        truncate(text, length) {
            if (!text) return ''
            return text.length > length ? text.substring(0, length) + '...' : text
        },
        formatDate(date) {
            if (!date) return '';
            return moment.tz(date, 'US/Eastern').format('DD MMM YYYY h:mm:ss A');
        }
    },
}
</script>
<style lang="scss">
#modal-activity-logs .modal-header h3 {
    justify-content: center !important;
    text-align: center !important;
}

#modal-activity-logs .modal-title {
    width: 100%;
}

.modal-body-scroll {
    max-height: 60vh;
    overflow-y: initial;
    padding-right: 10px;
}
</style>